import moment    from 'moment'
import Countdown from 'react-countdown';
import React     from 'react'

import { OnSchedUtils } from '../../../utils';


const AvailabilityDetails = ({ element, availability }) => {
  if (!availability || element.options.availabilityDetails === false)
    return null

  let duration = availability.serviceDuration ? availability.serviceDuration + ' min' : ''
  
  duration = availability.serviceDuration ? availability.serviceDuration + ' min' : ''
  
  return (
    <div>
      <h5 className='AvailabilityCalendarTitle'>
        <i className="onsched-primary-color fa-light fa-timer"></i>
        {duration}
        <i className="onsched-primary-color fa-light fa-bell"></i>
        {availability.serviceName}
        <i className="onsched-primary-color fa-light fa-user"></i>
        {availability.resourceName}
      </h5>
    </div>
  )
}

export default AvailabilityDetails